import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent, ref } from "vue"; // modules

import CustomersModule from "@/store/modules/customers";
import CommonModule from "@/store/modules/common";
import AppModule from "@/store/modules/app"; // helpers

import { dialogVisibleForStatus, hideDialog, toggleModalVisible } from "@/utils/vue-helpers/modal"; // import { parseFieldsResult, parseFilter } from "@/app-search/helpers/app-search.helpers";
// constants

import { ModalStatus } from "@/constants/modal";
export default defineComponent({
  name: "Customers",
  components: {},
  setup: function setup() {
    var modalVisibility = dialogVisibleForStatus(ModalStatus.Customers);
    var isLoading = ref(false);
    var searchValue = ref(""); // TODO: Hidden footer since we can display only one customer per booking for now

    var isShowFooter = ref(false);
    var customersTable = ref(); // const filter = parseFieldsResult(CustomersModule.getCurrentViewFilters, {});

    var filter = CustomersModule.filter;
    fetchData(filter);
    CommonModule.fetchCountries({
      lang: AppModule.language
    });

    var onSearch = function onSearch(value) {
      searchValue.value = value || "";
      searchEvent();
    };

    var searchEvent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var filterSearch;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                filterSearch = _objectSpread(_objectSpread({}, filter), {}, {
                  options: _objectSpread(_objectSpread({}, filter.options), {}, {
                    page: _objectSpread(_objectSpread({}, filter.options.page), {}, {
                      current: 1
                    }),
                    search_fields: {
                      full_name: {},
                      first_name: {},
                      last_name: {},
                      email: {}
                    }
                  }),
                  query: searchValue.value
                });
                _context.next = 3;
                return fetchData(filterSearch);

              case 3:
                return _context.abrupt("return", true);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchEvent() {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Get table data
     *
     * @returns {void}
     */


    function fetchData(filter) {
      // CustomersModule.fetchCustomers(parseFilter(filter));
      CustomersModule.fetchCustomers(filter);
    }

    var onSave = function onSave() {
      isLoading.value = true;
      setTimeout(function () {
        isLoading.value = false;
        hideDialog();
      }, 500);
    };

    return {
      modalVisibility: modalVisibility,
      isLoading: isLoading,
      searchValue: searchValue,
      isShowFooter: isShowFooter,
      customersTable: customersTable,
      ModalStatus: ModalStatus,
      onSearch: onSearch,
      hideDialog: hideDialog,
      toggleModalVisible: toggleModalVisible,
      onSave: onSave
    };
  }
});